module.exports = __webpack_public_path__ + "static/media/chevron-left.22991968.svg";